import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { jobsEndpoint } from "../constants";
import Logo from "../assets/logo.svg";


const CompaniesList = () => {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  const mockCompanies = [
    {
      id: 1,
      name: "Morph & Mind",
      logo: "",
      size: "50-100",
      jobs_count: 5,
      location: "London, UK",
      industry: "AI & Tech",
      website: "morphandmind.com"
    },
    {
      id: 2,
      name: "TechCorp",
      logo: "",
      size: "200-500",
      jobs_count: 12,
      location: "Berlin, Germany",
      industry: "Software",
      website: "techcorp.com"
    },
    {
      id: 3,
      name: "DesignStudio",
      logo: "",
      size: "20-50",
      jobs_count: 2,
      location: "Paris, France",
      industry: "Design",
      website: "designstudio.fr"
    },
  ];

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const response = await fetch(jobsEndpoint+'companies/', {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`,
          },
        });
        if (!response.ok) throw new Error('Failed to fetch companies');
        const data = await response.json();
        setCompanies(Array.isArray(data) ? data : data.results || data.companies || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchCompanies();
  }, [token]);

  const filteredCompanies = companies.filter(company =>
    company.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    company.website?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const displayCompanies = filteredCompanies.length === 0 && !loading ? mockCompanies : filteredCompanies;

  return (
    <div className="min-h-screen bg-gray-50 px-4 py-8">
      <div className="max-w-5xl mx-auto">
        <div className="mb-8">
          <div className="text-left">
            <h1 className="text-xl font-bold text-gray-900 mb-1">Companies</h1>
            <p className="text-sm text-gray-500 mb-6">Here is a complete overview of all Companies</p>
          </div>
        </div>
        <div className="flex justify-between items-center mb-6">
          <div className="text-gray-600 text-lg">
            Total Companies: <span className="font-bold text-green-600">{filteredCompanies.length}</span>
          </div>
        </div>
        <div className="overflow-x-auto bg-white rounded-xl shadow border border-gray-200">
          <table className="min-w-full divide-y divide-gray-200 text-sm">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Company</th>
                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Size</th>
                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Jobs</th>
                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Location</th>
                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Industry</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-100 text-xs">
              {loading ? (
                <tr><td colSpan={5} className="text-center py-6 text-gray-400">Loading...</td></tr>
              ) : displayCompanies.length === 0 ? (
                <tr><td colSpan={5} className="text-center py-6 text-gray-400">No companies found</td></tr>
              ) : (
                displayCompanies.map(company => (
                  <tr
                    key={company.id}
                    className="hover:bg-gray-50 cursor-pointer transition group"
                    onClick={() => navigate(`/candidate/company-profile/${company.id}`)}
                  >
                    <td className="px-3 py-2 whitespace-nowrap flex items-center gap-2">
                      <input type="checkbox" className="mr-2" />
                      <img 
                        src={Logo} 
                        alt="Company Logo" 
                        className="w-8 h-8 rounded-full object-cover border border-gray-200" 
                      />
                      <div>
                        <div className="font-semibold text-gray-900 group-hover:text-green-700 text-xs">{company.name}</div>
                        <div className="text-[10px] text-gray-500">{company.website || ''}</div>
                      </div>
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap text-gray-700">{company.size || '-'}</td>
                    <td className="px-3 py-2 whitespace-nowrap text-gray-700">{company.jobs_count || '-'}</td>
                    <td className="px-3 py-2 whitespace-nowrap text-gray-700">{company.location || '-'}</td>
                    <td className="px-3 py-2 whitespace-nowrap text-gray-700">{company.industry || '-'}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CompaniesList;